import { ReminderListDatastore } from '../datasources/personal_reminder_list_datasource';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { IReminderData } from '../personal_reminder_interface';
import { ORM } from 'utility-ts-orm';
import * as _4 from 'lodash4';

export class ReminderListQuery implements IQuery {
  private _result: IReminderData[];

  constructor(private reminderListDatastore: ReminderListDatastore, private EventCategoryEnum: any) {
    ORM.registerQuery(this, reminderListDatastore);
  }

  run(): ReminderListQuery {
    this._result = this.reminderListDatastore.read();
    this.setUpRemindersFields();
    return this;
  }

  get result() {
    return this._result;
  }

  setUpRemindersFields(): void {
    _4.forEach(this._result, (reminder: IReminderData) => {
      const dateTime = moment(reminder.due_ts as string);

      reminder.category = this.EventCategoryEnum.PERSONAL_REMINDER;
      reminder.isAllDayReminder = dateTime.hours() === 0 && dateTime.minutes() === 0;
      reminder.show = true;
    });
  }

  removeReminder(reminder: IReminderData): void {
    _4.remove(this._result, (currReminder: IReminderData) => {
      return reminder.id === currReminder.id;
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/queries/reminder_list_query.ts